module.exports = __webpack_public_path__ + "img/22.04412f95.png";